import { ApiRequest } from "./api-request"
import { ApiMethods, ERROR_MESSAGE } from "../utils/constants"

export async function saveInvoice(data) {
  try {
    const response = await ApiRequest({
      url: "/invoice/save",
      method: ApiMethods.POST,
      data,
    })
    const responseData = response.data
    return responseData
  } catch (error) {
    return error
  }
}

export async function getPatientInvoice(data) {
  try {
    const response = await ApiRequest({
      url: "/invoice/getByPatientId",
      method: ApiMethods.GET,
      params: data,
    })
    const responseData = response.data
    return responseData
  } catch (error) {
    return error
  }
}
